module.exports = {"ru":{"modules":{"stampcard":{"title":"Штамп-карта","card":{"action":"Получить подарок!"},"popup":{"title":"Получить подарок"}}}}}